export const ModifyCustomerDetails = (customerDetails) => {
  const customerInformation = {
    clientId: customerDetails.clientId,
    name: customerDetails.name,
    shortName: customerDetails.shortName,
    customerType: customerDetails.customerType,
    customerCode: customerDetails.customerCode,
    status: customerDetails.status,
    hasSeparateDispenseCount: customerDetails.hasSeparateDispenseCount,
    requiresEVhr: customerDetails.requiresEVhr,
    requestedBy: customerDetails.requestedBy,
    comments: customerDetails.comments,

    offeredServices: customerDetails.offeredServices.map((service) => ({
      serviceName: service.serviceName,
      expanded: false,
      cassettes: service.cassettes.map((cassette) => ({
        description: cassette.description,
        denomination: cassette.denomination,
        currency: cassette.denomination.split(" ")[0],
        multiple: cassette.denomination.split(" ")[1],
        cassetteType: cassette.cassetteType,
        maker: cassette.maker,
        limit: cassette.limit,
        dualScanning: cassette.dualScanning,
      })),
      denominations: service.denominations.map((deno) => ({
        denominationCurrency: deno.currency,
        denominationMultiple: deno.multiple?.toString(),
        shape: deno.shape,
        version: deno.version,
      })),
    })),
    accounts: customerDetails.accounts,
    contactPersons: customerDetails.contactPersons,
    insuranceLimits: customerDetails.insuranceLimits.map((limit) => ({
      type: limit.type,
      currency: limit.currency,
      pavement: limit.pavement,
      van: limit.van,
      bag: limit.bag,
    })),
    replenishmentModels: customerDetails.replenishmentModels.map((model) => ({
      code: model.code,
      expanded: false,
      denominations: model.denominations.map((deno) => ({
        currency: deno.denomination.split(" ")[0],
        multiple: deno.denomination.split(" ")[1],
        noOfCassettes: deno.noOfCassettes,
        noOfNotes: deno.noOfNotes,
      })),
    })),
    contracts: customerDetails.contracts.map((contract) => ({
      contractCode: contract.contractCode,
      autoRenew: contract.autoRenew,
      autoRenewFor: contract.autoRenewFor,
      startDate: contract.startDate ? new Date(contract.startDate) : null,
      endDate: contract.endDate ? new Date(contract.endDate) : null,
      status: contract.status,
      // contractStatus.filter((elm) => elm.value === contract.status)[0],
      expanded: false,
      contractSLAs: contract.contractSLAs.map((sla) => ({
        city: { id: sla.city, text: sla.city },
        serviceType: sla.serviceType,
        activityType: sla.activityType,
        responseTime: sla.responseTime,
        attendedTime: sla.attendedTime,
        resolutionTime: sla.resolutionTime,
      })),
      invoicingCatalogs: contract.invoicingCatalogs.map((catalog) => ({
        invoicingCode: catalog.invoicingCode,
        currency: catalog.currency,
        rate: catalog.rate,
        discount: catalog.discount,
      })),
    })),
    escalationGroups: customerDetails.escalationGroups.map((group) => {
      const item = {
        region: group.region,
        routeNo: group.routeNo,
        escalationLevel: group.escalationLevel,
        inAppRecipients: group.inAppRecipients.map((elm) => ({ item: elm })),
        emailRecipients: group.emailRecipients.map((elm) => ({ item: elm })),
        callRecipients: group.callRecipients.map((elm) => ({ item: elm })),
      };
      return item;
    }),
    locationInitials: customerDetails.locationInitials || [],

    serviceWindows: customerDetails?.serviceWindows || [],
    lastCallTimings: customerDetails?.lastCallTimings || [],
  };
  const modifiedCustomer = { ...customerDetails, ...customerInformation };

  return modifiedCustomer;
};
